var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 135,
    viewBox: "0 0 93 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4149_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0855 79.7099C71.0855 98.551 54.7215 113.824 34.5349 113.824C14.3487 113.824 -2.01562 98.551 -2.01562 79.7099C-2.01562 60.8694 14.3487 45.5962 34.5349 45.5962C54.7215 45.5962 71.0855 60.8694 71.0855 79.7099Z",
    fill: "url(#paint0_linear_4149_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5586 38.0151H36.9734V46.679H31.5586V38.0151Z",
    fill: "url(#paint1_linear_4149_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2645 39.0973C38.4513 39.0973 41.8454 35.7032 41.8454 31.5164C41.8454 27.3296 38.4513 23.9355 34.2645 23.9355C30.0777 23.9355 26.6836 27.3296 26.6836 31.5164C26.6836 35.7032 30.0777 39.0973 34.2645 39.0973Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7719 52.0643L56.772 52.0644C66.2056 58.4042 72.2953 68.6856 72.2953 80.2515C72.2953 99.3599 55.615 115.031 34.8079 115.031C14.0005 115.031 -2.67969 99.3599 -2.67969 80.2515C-2.67969 68.6856 3.40966 58.4042 12.8433 52.0644C13.4796 51.6367 14.2634 51.4136 15.0962 51.4136H54.519C55.352 51.4136 56.1359 51.6368 56.7719 52.0643Z",
    fill: "url(#paint2_linear_4149_12)",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3039 98.629C71.9581 100.766 70.2274 102.35 68.5402 103.196C66.8434 104.046 65.2759 104.116 64.1488 103.407C63.0217 102.697 62.4074 101.253 62.4411 99.3553C62.4745 97.4684 63.1549 95.2232 64.5008 93.0858C65.8466 90.9485 67.5774 89.3646 69.2645 88.519C70.9613 87.6685 72.5288 87.5986 73.6559 88.3083C74.783 89.018 75.3973 90.4618 75.3637 92.3595C75.3302 94.2464 74.6498 96.4917 73.3039 98.629Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 97C75 99 81.5 100.5 85.5 87.5",
    stroke: "white",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97004 107.308C5.67225 109.174 7.65554 110.427 9.46552 110.962C11.2859 111.499 12.8411 111.291 13.8251 110.393C14.8091 109.496 15.1587 107.966 14.7904 106.104C14.4242 104.253 13.3578 102.163 11.6556 100.297C9.95342 98.4311 7.97012 97.1779 6.16015 96.6436C4.33975 96.1062 2.78457 96.3142 1.80057 97.2119C0.816559 98.1095 0.466926 99.6391 0.835274 101.501C1.20151 103.352 2.26783 105.442 3.97004 107.308Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4593 105.386C2.36761 107.973 -3.76523 110.598 -9.99861 98.5086",
    stroke: "white",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 86.5,
    r: 7,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.862 107.321C11.9818 106.202 11.1882 103.593 9.08953 101.493C6.99084 99.3934 4.38174 98.5987 3.26195 99.718C2.14215 100.837 2.9357 103.447 5.03439 105.546C7.13307 107.646 9.74217 108.441 10.862 107.321Z",
    fill: "#236DC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0699 108.866C14.5391 107.375 13.3123 103.784 10.3299 100.846C7.34745 97.9074 3.73869 96.7341 2.26946 98.2252C0.800273 99.7163 2.02698 103.307 5.00944 106.246C7.99186 109.184 11.6007 110.358 13.0699 108.866ZM10.5076 106.954C11.4425 106.005 10.6619 103.72 8.76424 101.851C6.86651 99.981 4.57025 99.2346 3.63546 100.183C2.70061 101.132 3.48113 103.417 5.37885 105.287C7.27653 107.157 9.57279 107.903 10.5076 106.954Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33503 104.781L11.0098 102.654L6.75507 99.3047L5.08035 101.432L9.33503 104.781ZM-5.44422 101.843C-6.14186 100.521 -7.77962 100.014 -9.10215 100.712C-10.4247 101.41 -10.9312 103.047 -10.2335 104.37L-5.44422 101.843ZM5.08035 101.432C3.59337 103.321 2.50252 104.071 1.81386 104.407C1.07974 104.765 0.716485 104.749 -0.247487 104.941L0.814449 110.251C1.20421 110.173 2.63342 110.033 4.18819 109.274C5.78848 108.493 7.48287 107.134 9.33503 104.781L5.08035 101.432ZM-0.247487 104.941C-0.111686 104.914 -0.294094 104.972 -0.924459 104.776C-1.47758 104.605 -2.14761 104.309 -2.83643 103.921C-3.52176 103.535 -4.15854 103.095 -4.65639 102.672C-4.90383 102.461 -5.09736 102.271 -5.23838 102.112C-5.3079 102.033 -5.35868 101.969 -5.39417 101.919C-5.4116 101.895 -5.42407 101.877 -5.43253 101.863C-5.44098 101.85 -5.44443 101.843 -5.44422 101.843L-10.2335 104.37C-9.72902 105.327 -8.92005 106.154 -8.16479 106.796C-7.36888 107.473 -6.43972 108.106 -5.49443 108.639C-4.55264 109.169 -3.52744 109.638 -2.52835 109.948C-1.60655 110.234 -0.37979 110.49 0.814449 110.251L-0.247487 104.941Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31354 104.806L11.0137 102.699L6.79969 99.2984L5.09946 101.406L9.31354 104.806ZM-5.07 100.868C-5.6451 99.4884 -7.23025 98.8355 -8.6105 99.4106C-9.99075 99.9858 -10.6435 101.571 -10.0684 102.951L-5.07 100.868ZM-10.0684 102.951C-9.93099 103.281 -9.77269 103.599 -9.59931 103.904L-4.89271 101.226C-4.96677 101.096 -5.02507 100.976 -5.07 100.868L-10.0684 102.951ZM1.57076 110.18C1.98902 110.121 2.41297 110.022 2.83217 109.869L0.981675 104.781C0.951561 104.792 0.901508 104.806 0.826248 104.816L1.57076 110.18ZM2.83217 109.869C2.9651 109.821 3.08863 109.777 3.20382 109.738L1.44205 104.617C1.29795 104.667 1.14482 104.721 0.981675 104.781L2.83217 109.869ZM9.0424 105.143C9.1293 105.035 9.21959 104.923 9.31354 104.806L5.09946 101.406C5.00228 101.526 4.90886 101.642 4.81903 101.754L9.0424 105.143Z",
    fill: "#0F4688"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8491 104.19C12.2741 103.077 11.4196 101.918 10.3314 100.846C8.64375 99.1834 6.75557 98.0858 5.16797 97.7163L5.8379 99.96C6.76659 100.261 7.81605 100.916 8.76572 101.851C9.52719 102.601 10.1088 103.419 10.4719 104.19H12.8491Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2686 100.499C65.8828 99.7336 65.9231 97.0064 67.3587 94.408C68.7942 91.8095 71.0814 90.3237 72.4673 91.0893C73.8531 91.8549 73.8128 94.5821 72.3773 97.1805C70.9417 99.779 68.6545 101.265 67.2686 100.499Z",
    fill: "#236DC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5761 102.595C63.752 101.568 63.9367 97.7782 65.9894 94.129C68.0421 90.4803 71.1851 88.354 73.0097 89.3801C74.8343 90.4067 74.649 94.1968 72.5963 97.846C70.5441 101.495 67.4007 103.621 65.5761 102.595ZM67.5092 100.048C66.3485 99.3956 66.4659 96.9838 67.7723 94.6618C69.0781 92.3398 71.0781 90.987 72.2388 91.64C73.4001 92.2934 73.2821 94.7046 71.9763 97.0266C70.6699 99.3486 68.67 100.701 67.5092 100.048Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0337 97.6351L65.8359 96.0542L68.9972 91.6581L71.1955 93.239L68.0337 97.6351ZM81.4223 90.7213C81.7271 89.2573 83.1603 88.3174 84.6243 88.6217C86.0882 88.9259 87.0282 90.3596 86.7239 91.8236L81.4223 90.7213ZM71.1955 93.239C73.1469 94.6424 74.4031 95.0615 75.1578 95.1941C75.9621 95.335 76.3065 95.2181 77.2862 95.1367L77.7355 100.533C77.3394 100.566 75.9271 100.826 74.2231 100.528C72.4694 100.22 70.4648 99.3835 68.0337 97.6351L71.1955 93.239ZM77.2862 95.1367C77.1484 95.1482 77.3394 95.1529 77.8911 94.7901C78.3749 94.4723 78.9375 94.0031 79.4918 93.4399C80.0434 92.8789 80.5335 92.2797 80.8947 91.7349C81.0742 91.4645 81.2078 91.2286 81.2992 91.036C81.344 90.9416 81.3748 90.8654 81.3957 90.8085C81.4056 90.7803 81.4124 90.7584 81.4166 90.7432C81.4213 90.7281 81.4228 90.7208 81.4223 90.7213L86.7239 91.8236C86.5042 92.882 85.9557 93.9013 85.4076 94.7275C84.8304 95.5981 84.1128 96.4639 83.3518 97.2374C82.5935 98.0077 81.7381 98.7421 80.8639 99.3162C80.057 99.8464 78.949 100.432 77.7355 100.533L77.2862 95.1367Z",
    fill: "#000F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0603 97.6536L65.8438 96.0994L68.9517 91.6657L71.1688 93.2195L68.0603 97.6536ZM80.7924 89.8886C80.963 88.4033 82.3054 87.3375 83.7907 87.5082C85.2766 87.6783 86.3424 89.0212 86.1717 90.5066L80.7924 89.8886ZM86.1717 90.5066C86.131 90.8615 86.0668 91.2106 85.9849 91.5514L80.7209 90.2811C80.7558 90.136 80.7788 90.005 80.7924 89.8886L86.1717 90.5066ZM76.9881 100.674C76.5701 100.734 76.1348 100.755 75.6901 100.725L76.0597 95.3228C76.0915 95.3249 76.1437 95.3249 76.2188 95.3139L76.9881 100.674ZM75.6901 100.725C75.5487 100.715 75.4182 100.708 75.2966 100.702L75.5722 95.2936C75.7246 95.3014 75.8864 95.3108 76.0597 95.3228L75.6901 100.725ZM68.4142 97.9026C68.3009 97.8222 68.183 97.7392 68.0603 97.6536L71.1688 93.2195C71.2956 93.3087 71.4172 93.3943 71.5347 93.4768L68.4142 97.9026Z",
    fill: "#0F4688"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4922 98.0388C64.737 96.8112 65.2375 95.461 65.9864 94.1291C67.1477 92.0644 68.6586 90.4872 70.0819 89.6929L70.0589 92.0342C69.2499 92.5806 68.4227 93.5002 67.7693 94.662C67.2448 95.5936 66.9123 96.5398 66.7766 97.3812L64.4922 98.0388Z",
    fill: "#468BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1211 91.8219C80.0456 91.0232 78.1999 87.8826 78.9986 84.8071C79.7973 81.7317 82.9379 79.886 86.0134 80.6847C89.0889 81.4834 90.9346 84.624 90.1359 87.6995C89.3372 90.775 86.1965 92.6206 83.1211 91.8219Z",
    fill: "#85B7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0427 102.316C33.0427 102.092 32.8609 101.91 32.6366 101.91C32.4123 101.91 32.2305 102.092 32.2305 102.316V107.19C32.2305 107.414 32.4123 107.596 32.6366 107.596C32.8609 107.596 33.0427 107.414 33.0427 107.19V102.316Z",
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9177 102.316C37.9177 102.092 37.7359 101.91 37.5116 101.91C37.2873 101.91 37.1055 102.092 37.1055 102.316V107.19C37.1055 107.414 37.2873 107.596 37.5116 107.596C37.7359 107.596 37.9177 107.414 37.9177 107.19V102.316Z",
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4802 100.692C35.4802 100.467 35.2984 100.286 35.0741 100.286C34.8498 100.286 34.668 100.467 34.668 100.692V109.626C34.668 109.851 34.8498 110.032 35.0741 110.032C35.2984 110.032 35.4802 109.851 35.4802 109.626V100.692Z",
    fill: "#5998E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8289 59.6738H20.0467C10.9255 59.6738 3.53125 67.0681 3.53125 76.1893C3.53125 85.3105 10.9255 92.7048 20.0467 92.7048H49.8289C58.9502 92.7048 66.3444 85.3105 66.3444 76.1893C66.3444 67.0681 58.9502 59.6738 49.8289 59.6738Z",
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 2.16596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3573 74.2942C27.3573 73.5829 27.2169 72.8788 26.945 72.2217C26.6726 71.5652 26.2738 70.9681 25.7711 70.465C25.2683 69.9624 24.6714 69.5636 24.0144 69.2912C23.3575 69.0193 22.6533 68.8794 21.9422 68.8794C21.2311 68.8794 20.527 69.0193 19.87 69.2912C19.2131 69.5636 18.6161 69.9624 18.1133 70.465C17.6105 70.9681 17.2116 71.5652 16.9395 72.2217C16.6674 72.8788 16.5273 73.5829 16.5273 74.2942",
    stroke: "#72B2FF",
    strokeWidth: 2.70746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6875 91.3276C79.723 95.7848 83.9787 104.39 92.7202 103.152",
    stroke: "#72F06F",
    strokeWidth: 1.43951
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4318 74.2942C54.4318 73.5829 54.2914 72.8788 54.0195 72.2217C53.747 71.5652 53.3483 70.9681 52.8457 70.465C52.3426 69.9624 51.746 69.5636 51.0889 69.2912C50.4318 69.0193 49.7278 68.8794 49.0169 68.8794C48.3056 68.8794 47.6015 69.0193 46.9444 69.2912C46.2873 69.5636 45.6908 69.9624 45.1877 70.465C44.6851 70.9681 44.2863 71.5652 44.0139 72.2217C43.742 72.8788 43.6016 73.5829 43.6016 74.2942",
    stroke: "#72B2FF",
    strokeWidth: 2.70746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0132 117.721L39.418 110.523L37.9026 111.701L43.4979 118.899L45.0132 117.721Z",
    fill: "#EBA149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.77344 37.876C-1.0966 38.6901 -0.483511 37.876 2.32615 38.1828",
    stroke: "#63A5F0",
    strokeWidth: 3.35885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3109 103.806L40.1929 110.341L37.1825 112.683C37.1825 112.683 36.3803 111.901 36.2227 111.244C36.0959 110.716 36.4628 109.564 35.9826 109.085C35.503 108.605 34.6836 107.645 34.6836 107.645V105.966V104.286L35.3109 103.806Z",
    fill: "#F6DA76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2064 108.887L40.292 110.341L37.1825 112.683L36.4622 111.723L36.2227 111.244V111.004L39.2064 108.887Z",
    fill: "#EBC749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5379 120.6C48.658 120.6 50.3766 118.882 50.3766 116.762C50.3766 114.641 48.658 112.923 46.5379 112.923C44.4179 112.923 42.6992 114.641 42.6992 116.762C42.6992 118.882 44.4179 120.6 46.5379 120.6Z",
    fill: "#EBA049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9414 115.082C43.8208 116.761 45.9643 119.688 47.4998 117.961C49.4189 115.802 47.0202 114.842 46.54 115.082C46.0604 115.321 44.6209 116.281 45.5802 117.001C46.3479 117.577 46.8599 116.921 47.0202 116.521",
    stroke: "#D3852A",
    strokeWidth: 0.479836
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8828 67.7134C84.9595 69.5886 85.6902 67.7134 88.2731 70.5849",
    stroke: "#63A5F0",
    strokeWidth: 3.35885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2391 46.5495L35.4353 8.8424L48.9131 47.6044L19.2391 46.5495Z",
    fill: "#FCE07E",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5731 37.3306L47.2493 38.2433L49.0865 43.5901L19.3555 42.5332L21.5731 37.3306Z",
    fill: "#C47FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8439 25.0347L42.8447 25.6034L44.734 30.9522L24.5938 30.2362L26.8439 25.0347Z",
    fill: "#C47FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9421 10.8472L37.7823 11.0192L39.6461 16.367L30.7109 16.0494L32.9421 10.8472Z",
    fill: "#C47FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4492 49.0533L51.0457 49.1812L35.5819 4.69873L33.75 8.95487L47.4492 49.0533Z",
    fill: "#201919",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7344 42.2036C68.2202 46.0454 71.8209 49.3437 80.6981 50.3034",
    stroke: "#FF9154",
    strokeWidth: 1.43951
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 7C67 7.5 67.5 10 68 14C68.5 10 70 7.5 75 7C70 6.5 68.5 4 68 0C67.5 4 67 6.5 61 7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4149_12",
    x1: 34.5349,
    y1: 38.0153,
    x2: 34.5349,
    y2: 113.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4149_12",
    x1: 34.5366,
    y1: 38.0151,
    x2: 34.5366,
    y2: 113.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4149_12",
    x1: 34.8079,
    y1: 43.9713,
    x2: 34.8079,
    y2: 116.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4149_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.996,
    height: 131,
    fill: "white",
    transform: "translate(-26 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.0a726ec440e58fa173c4ff879b6ed742.svg";
export { ForwardRef as ReactComponent };